var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callback"},[(!_vm.hasLoginError)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("processing...")])]):_c('div',{staticClass:"error"},[_c('p',[_vm._v("ログインに失敗しました。")]),_c('p',[_vm._v(_vm._s(_vm.errorReason))])])])}
var staticRenderFns = []

export { render, staticRenderFns }